<template>
  <div class="orgchart-body node" draggable="true"
       @mouseenter.prevent="activeChevron(true, data, rootNode)"
       @mouseleave.prevent="activeChevron(false, data, rootNode)">
    <div v-if="data.imgsupvipath !== ''"><img class="avatar" :src="'data:image/jpeg;base64,' + data.imgsupvipath"></div>
    <div v-else><img class="avatar" src="~static/images/employee/no_image.png"></div>
    <div class="name color-skin">{{ data.desc_supvi }}</div>
    <a @click="receivedOrgBodyDetail(data)" class="cursor-pointer">
      <div class="company">{{ data.desc_codcomp }}</div>
      <div class="position">{{ data.desc_codpos }}</div>
    </a>
    <div><i :class="'edge horizontalEdge leftEdge fa ' + classLeftEdge" @click="toggleSiblingNode()" ></i></div>
    <div><i :class="'edge horizontalEdge rightEdge fa ' + classRightEdge" @click="toggleSiblingNode()" ></i></div>
    <div><i :class="'edge verticalEdge bottomEdge fa ' + classBottomEdge" @click="toggleBottomNode()" ></i></div>
    <div class="cover-assist-icon">
      <i v-if="data.codassis !== '' && !data.assistActive"
       class="assist-icon fa fa-plus-circle cursor-pointer" @click="setActiveAssistNode(true)"></i>
      <i v-if="data.codassis !== '' && data.assistActive"
       class="assist-icon fa fa-minus-circle cursor-pointer" @click="setActiveAssistNode(false)"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orgchart-body',
  data () {
    return {
      classLeftEdge: '',
      classRightEdge: '',
      classBottomEdge: ''
    }
  },
  methods: {
    activeChevron (chevronDisp) {
      this.findClassLeftEdge(chevronDisp)
      this.findClassRightEdge(chevronDisp)
      this.findClassBottomEdge(chevronDisp)
    },
    findClassLeftEdge (chevronDisp) {
      if (chevronDisp && !this.rootNode && this.siblingNodeCounted > 1) {
        this.classLeftEdge = (this.data.targetSide) ? 'fa-chevron-left' : 'fa-chevron-right'
      } else {
        this.classLeftEdge = ''
      }
    },
    findClassRightEdge (chevronDisp) {
      if (chevronDisp && !this.rootNode && this.siblingNodeCounted > 1) {
        this.classRightEdge = (this.data.targetSide) ? 'fa-chevron-right' : 'fa-chevron-left'
      } else {
        this.classRightEdge = ''
      }
    },
    findClassBottomEdge (chevronDisp) {
      if (chevronDisp && typeof this.data.children !== 'undefined') {
        this.classBottomEdge = (this.data.targetBottom) ? 'fa-chevron-down' : 'fa-chevron-up'
      } else {
        this.classBottomEdge = ''
      }
    },
    toggleSiblingNode () {
      if (this.data.targetSide) {
        this.$set(this.data, 'targetSide', false)
        this.activeAllSiblingNode()
      } else {
        this.$set(this.data, 'targetSide', true)
        this.inActiveAllSiblingNode()
      }
      this.activeChevron(true)
    },
    toggleBottomNode () {
      if (this.data.targetBottom) {
        this.$set(this.data, 'targetBottom', false)
        this.activeChildrenNode()
      } else {
        this.$set(this.data, 'targetBottom', true)
        this.inActiveChildrenNode()
      }
      this.activeChevron(true)
    },
    activeAllSiblingNode () {
      let _this = this
      this.siblingNodes.map(function (siblingNode) {
        if (siblingNode.orgid !== _this.data.orgid) {
          _this.$set(siblingNode, 'active', true)
        } else {
          _this.$set(_this.data, 'active', true)
        }
      })
    },
    inActiveAllSiblingNode () {
      let _this = this
      this.siblingNodes.map(function (siblingNode) {
        if (siblingNode.orgid !== _this.data.orgid) {
          _this.$set(siblingNode, 'active', false)
        } else {
          _this.$set(_this.data, 'active', true)
        }
      })
    },
    activeChildrenNode () {
      let _this = this
      this.data.children.map(function (childNode) {
        _this.$set(childNode, 'active', true)
      })
    },
    inActiveChildrenNode () {
      let _this = this
      this.data.children.map(function (childNode) {
        _this.$set(childNode, 'active', false)
        _this.$set(childNode, 'targetBottom', false)
      })
    },
    closeModal () {
      this.showModal = false
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    labels: {
      type: Object
    },
    rootNode: {
      type: Boolean,
      default: false
    },
    siblingNodeCounted: {
      type: Number,
      default: 0
    },
    siblingNodes: {
      type: Array,
      default () {
        return []
      }
    },
    setActiveAssistNode: {
      type: Function
    },
    receivedOrgBodyDetail: {
      type: Function
    }
  }
}
</script>

<style lang="scss">
  .orgchart-body{
    .cover-assist-icon {
      position: absolute;
      width: 100%;
      .assist-icon {
        position: relative;
        right: -80px;
        bottom: 5px;
      }
    }

    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      transition: opacity .3s ease;
      overflow: auto;
      display: block;
    }

    .modal-wrapper {
      display: block;
    }

    .modal-container {
      width: 80%;
      max-width: 800px;
      margin: 30px auto;
      padding: 0;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      overflow-x: auto;
      // font-family: Helvetica, Arial, sans-serif;
      // @media (max-width: 480px) {
      //   margin: 0;
      //   width: 100%;
      // }
    }

    .modal-header h3 {
      margin-top: 0;
      color: #42b983;
    }

    .modal-body {
      margin: 10px 0;
      padding: 10px;
    }

    .modal-default-button {
      float: right;
    }

    .modal-enter {
      opacity: 0;
    }

    .modal-leave-active {
      opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }

    .modal-header .close {
      font-size: 32px;
      color: #fff;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// orgchartBody.vue?44ac9734